import { render, staticRenderFns } from "./GestaoInventarioFilter.vue?vue&type=template&id=f0b12a18"
import script from "./GestaoInventarioFilter.vue?vue&type=script&lang=js"
export * from "./GestaoInventarioFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports